import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";

interface ApproveRejectActionsProps {
  contentType: "post" | "comment";
  i18nRoot: string;
  isApproving: boolean;
  onApprove: () => void;
  onReject: () => void;
  status: string | null;
}

export const ApproveRejectActions = ({
  status,
  i18nRoot,
  isApproving,
  onReject,
  onApprove,
  contentType,
}: ApproveRejectActionsProps) => {
  const shouldShowApproveButton = status === null || status === "rejected";
  const shouldShowRejectButton = status === null || status === "approved";
  return (
    <div className="flex items-center justify-end gap-4">
      {shouldShowApproveButton && (
        <Button variant="secondary" onClick={onApprove} disabled={isApproving}>
          {t([i18nRoot, `approve_${contentType}`])}
        </Button>
      )}
      {shouldShowRejectButton && (
        <Button variant="danger" onClick={onReject}>
          {t([i18nRoot, `reject_${contentType}`])}
        </Button>
      )}
    </div>
  );
};
